import clsx from "clsx";
import { forwardRef } from "react";
import classes from "./BaseButton.module.scss";

type PropsType = {
  navigate?: any;
};

const BaseButton = (
  props: React.ButtonHTMLAttributes<HTMLButtonElement> & PropsType,
  ref: React.LegacyRef<HTMLButtonElement>
) => {
  const { children, type = "button", className, navigate, ...rest } = props;

  return (
    <button ref={ref} className={clsx(classes["base-button"], className)} type={type} {...rest}>
      {children}
    </button>
  );
};

export default forwardRef(BaseButton);
